// extracted by mini-css-extract-plugin
var _1 = "PageProfile__content--uNY33";
var _2 = "PageProfile__contentContainer--ZsaY3 CoreGeneral__robotoSlab--X8lgW";
var _3 = "PageProfile__demoTutorialContainer--edwUF";
var _4 = "PageProfile__main--Tu4Q_ ba-page-container";
var _5 = "PageProfile__pageBackground--K4NZv ba-page-background CoreGeneral__profile--Pp3VS CoreGeneral__argyle--mVDNO CoreGeneral__pageArgyle--bdxl4 CoreGeneral__pageBG--w94xk CoreGeneral__pageArgyleAddition--HsqQw";
var _6 = "PageProfile__pageTop--yBRWS ba-page-top";
var _7 = "PageProfile__selectorReturn--SMbPt general__shadow--ifbUf fontSize__profileText--q79uE";
var _8 = "PageProfile__selectorReturnText--KtwGk CoreGeneral__robotoSlab--X8lgW";
var _9 = "PageProfile__tabAvatar--OWrK7";
var _a = "PageProfile__tabContainer--d8P3f";
var _b = "PageProfile__tabIcon--mpK2m";
export { _1 as "content", _2 as "contentContainer", _3 as "demoTutorialContainer", _4 as "main", _5 as "pageBackground", _6 as "pageTop", _7 as "selectorReturn", _8 as "selectorReturnText", _9 as "tabAvatar", _a as "tabContainer", _b as "tabIcon" }
